module.exports = __webpack_public_path__ + "img/icon_campi.0ea0597e.svg";